import * as React from "react";

function SvgMsg91(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34.7 30"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M.1 11.5L33.1 0c.1 0 .2 0 .2.1V29.8c0 .1-.1.2-.2.2l-33-1.6c-.1 0-.2-.1-.2-.2V11.7c.1-.1.2-.1.2-.2zm92.8 17.6V14.5h-1.4l-3 1.7.4 1.2 2.4-1.4v13l1.6.1zM85 22.2c-.4 2.7-1.9 5.2-4.8 5.6l-1.5.1v1.3c3.7.2 6.4-2.1 7.5-5.6.9-3.3.6-9.4-4-9.4-5.7 0-6.3 9.5-.6 9.5 1.3.1 2.5-.4 3.4-1.5zm-3-6.7c2.4 0 3 2.7 2.9 4.7 0 2.6-5.8 4-5.8-.9.1-1.7 1-3.8 2.9-3.8zm-78.3-.8c-.4-.1-.7.1-.8.5-.1.3.1.7.5.8l12 3.5.3-.2 12-9.9c.3-.3.3-.7.1-1-.2-.3-.7-.3-.9-.1L15.1 18 3.7 14.7z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1e75ba"
      />
    </svg>
  );
}

export default React.forwardRef(SvgMsg91);
